import { Box, Typography, Button, Container, EmailOutlinedIcon, HomeOutlinedIcon } from 'src/components';
import { useNavigate } from 'react-router-dom';

export default function ContactUs() {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '80vh',
          textAlign: 'center',
          px: 2,
        }}
      >
        {/* Title */}
        <Typography
          variant="h3"
          sx={{ fontWeight: 'bold', mb: 2 }}
        >
          Contact The Team
        </Typography>

        {/* Description */}
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ mb: 3, lineHeight: 1.6 }}
        >
          We’d love to hear from you! Reach out with any questions or feedback by emailing:
        </Typography>

        {/* Email contact */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1,
            fontWeight: 600,
            fontSize: '1.1rem',
            mb: 4,
          }}
        >
          <EmailOutlinedIcon fontSize="medium" />
          <Typography
            component="a"
            href="mailto:panamexplorer@gmail.com"
            sx={{ textDecoration: 'underline', color: 'primary.main' }}
          >
            panamexplorer@gmail.com
          </Typography>
        </Box>

        {/* Go Home Button */}
        <Button
          variant="outlined"
          startIcon={<HomeOutlinedIcon />}
          onClick={handleGoHome}
          size="large"
          sx={{
            minWidth: 120,
            '&:hover': {
              backgroundColor: 'primary.light',
              borderColor: 'primary.main',
            },
          }}
        >
          Go Home
        </Button>
      </Box>
    </Container>
  );
}
